import React from 'react';
import { Link } from 'react-router-dom';
import { Container, makeStyles, Button, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  btn: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const ErrorPage = () => {
  const classes = useStyles();

  return (
    <Container component='main' maxWidth='xs'>
      <div className={classes.paper}>
        <Typography component='h1' variant='h1'>
          404
        </Typography>
        <Typography component='h3' variant='h5'>
          Désolé, la page que vous cherchez est introuvable
        </Typography>
        <Button
          component={Link}
          to='/'
          variant='contained'
          color='primary'
          className={classes.btn}
        >
          Revenir à l' accueil
        </Button>
      </div>
    </Container>
  );
};

export default ErrorPage;
